export default {
      id: "ic_alert_triangle-usage",
      viewBox: "0 0 50 45",
      url: "/" + "images/icons.3.109.2.svg#ic_alert_triangle-usage",
      toString: function () {
        return this.url;
      }
    }